import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
import { Loading } from '../Loading/Loading';
export const Button = ({ children, loading, startIcon, endIcon, collapse, disabled, disableEnterClick, ...props }) => {
    const handleKeyDown = (event) => {
        if (props.onKeyDown) {
            props.onKeyDown(event);
        }
        // Prevent the 'Enter' key from triggering onClick
        if (disableEnterClick && event.key === 'Enter') {
            event.preventDefault();
        }
    };
    return (_jsxs("button", { type: props.type || 'button', disabled: loading || disabled, ...props, onKeyDown: (event) => handleKeyDown(event), children: [startIcon && (_jsx("span", { className: `flex size-5 items-center ${collapse ? 'mx-0 md:-ml-1 md:mr-2' : '-ml-1 mr-2'}`, children: startIcon })), _jsx("span", { className: collapse ? 'hidden md:inline-block' : '', children: children }), endIcon && (_jsx("span", { className: twMerge('-mr-1 ml-2 flex size-5 items-center', props.className?.includes('btn-dense') ? 'ml-1' : '', collapse ? 'mx-0 md:-mr-1 md:ml-2' : ''), children: endIcon })), loading && _jsx(Loading, { className: "text-sourgum-greyblue-900", size: "h-4 w-4 ml-2" })] }));
};
//# sourceMappingURL=Button.js.map